// TODO find a better way to fix cycling import
// import axios from 'axios';
// import store from '../store';

const errorResponseInterceptor = (error) => {
  console.log('API Error interceptors', error);

  if (error.response && error.response.status === 401) {
    if (localStorage[process.env.VUE_APP_VUEX_KEY]) {
      localStorage.removeItem(process.env.VUE_APP_VUEX_KEY);
    }
    // localStorage.removeItem is not async when it should be,
    // so we use timeout until storage is clear to avoid loop between dashboard and login page
    setTimeout(() => {
      if (process.env.VUE_APP_COMPONENT_LOGIN) {
        console.log(window.location);
        // this.$router.push({ name: 'login' }).catch((err) => {});
        window.location.pathname = '/login';
      } else {
        const queryString = window.location.search.substring(1);
        window.location.href = `${process.env.VUE_APP_CAS_CLIENT}?redirect=${process.env.VUE_APP_SERVICE}${queryString ? `&platform-query=${queryString}` : ''}`;
      }
    }, 500);
    return Promise.reject(new Error({ msg: 'Permission denied' }));
  }

  const err = error;
  // format error message to avoid nested verification in component
  // err.msg = 'An error occurred. Please try again later.';
  if (error.response && error.response.data) {
    // General handled error
    if (error.response.data.error) {
      if (Array.isArray(error.response.data.error)) {
        [err.msg] = error.response.data.error;
      } else {
        err.msg = error.response.data.error;
      }
      if (error.response.data.error_key && !error.response.data.error) {
        if (Array.isArray(error.response.data.error_key)) {
          [err.msg] = error.response.data.error_key;
        } else {
          err.msg = error.response.data.error_key;
        }
      }
    } else if (error.response.data.non_field_errors) {
      [err.msg] = err.response.data.non_field_errors;
    } else if (error.response.data.detail) {
      if (Array.isArray(error.response.data.error)) {
        [err.msg] = err.response.data.detail;
      } else {
        err.msg = err.response.data.detail;
      }
    } else if (error.response.data.information) {
      [err.msg] = error.response.data.information;
    } else if (error.response.status !== 500
      && Object.keys(err.response.data).length > 0) {
      err.field = err.response.data;
    }

    // field validation error (for form inline error message)
    if (error.response.data.field) {
      let requestFields = [];
      let filteredFields = [];
      const responseFields = Object.keys(error.response.data.field);
      if (err.response.config.data instanceof FormData) {
        // When request payload is formData, data will be empty object
        requestFields = [...(err.response.config.data).keys()];
      } else if (err.response.config.data && Object.entries(err.response.config.data).length > 0) {
        requestFields = Object.keys(JSON.parse(err.response.config.data));
      }
      if (requestFields && requestFields.length) {
        filteredFields = requestFields.filter((el) => responseFields.includes(el));
      } else {
        filteredFields = responseFields;
      }
      if (filteredFields && filteredFields.length) {
        // Request and Response fields are matched at least one
        if (typeof error.response.data.field[responseFields[0]] === 'string') {
          err.msg = error.response.data.field[responseFields[0]];
        } else if (Array.isArray(error.response.data.field[responseFields[0]])) {
          err.msg = error.response.data.field[responseFields[0]].join(', ');
        } else if (typeof error.response.data.field[responseFields[0]] === 'object') {
          const msgs = [];
          Object.keys(error.response.data.field[responseFields[0]])
            .forEach((key) => msgs.push(error.response.data.field[responseFields[0]][key]));
          err.msg = msgs.join(', ');
        }
        err.field = error.response.data.field;
      } else if (responseFields && responseFields.length) {
        // Request and Response were not matched, but Response exist.
        [err.msg] = error.response.data.field[responseFields[0]];
      } else {
        // Else
        err.msg = 'Validation error';
      }
    }

    // Already submitted
    if (error.response.status === 406) {
      err.code = 406;
    }

    if (error.response.data.error_key) {
      err.key = error.response.data.error_key;
    }
  }

  // Default error message
  if (!err.msg && !err.field) {
    err.msg = 'An error occurred. Please try again later.';
  }

  return Promise.reject(err);
};

export default errorResponseInterceptor;
